// Pure helpers for the CMS users screen; goserver enforces the same with a 403.
export const SUPER_USER_ONLY_TIP = 'Only a Super user can change a Super user';

export const has_super_user = (access_type) =>
  (access_type || '')
    .split(',')
    .map((t) => t.trim().toUpperCase())
    .includes('SUPER_USER');

// Non-super viewers cannot grant SUPER_USER, so it is left out of the role options.
export const visible_access_types = (types, viewer_is_super) =>
  (types || []).filter((t) => viewer_is_super || String(t).trim().toUpperCase() !== 'SUPER_USER');

// A non-super viewer cannot edit a row that holds SUPER_USER.
export const can_edit_user = (user, viewer_is_super) =>
  viewer_is_super || !has_super_user(user && user.access_type);
